import { render } from "./index.vue?vue&type=template&id=3e67794a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3e67794a&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3e67794a&lang=less"
script.render = render
script.__scopeId = "data-v-3e67794a"

export default script